

import { defineComponent } from "vue";
import { IonChip, IonLabel } from "@ionic/vue";
import { useI18n } from "vue-i18n";

export default defineComponent({
  name: 'TheLangSelector',
  components: {
    IonChip,
    IonLabel
  },
  setup(){
    const { t } = useI18n()

    return {
      t
    }
  }
})
